import { useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PostStatus } from '../../data-layer/posts/constants';
import { PostModel } from '../../data-layer/posts/types';
import { PostStatusDrawer } from '../../ui/posts/PostStatusDrawer';
import { Typography } from '../../ui/typography/Typography';
import { EventSource } from '../../utils/analyticsService';
import { ymTrackServiceRulesClick } from '../../utils/metrika';
import { useBackButton } from '../../utils/useBackButton';
import { useTranslation } from '../../utils/useTranslation';
import { DEFAULT_CLOSE_ANIMATION_DELAY } from '../constants';
import { useCurrentUser } from '../users/useCurrentUser';
import { withPostCallbacks } from './withPostCallbacks';
const EnhancedPostStatusDrawer = withPostCallbacks(PostStatusDrawer, EventSource.POST);

const statusMap = {
    [PostStatus.MODERATION]: {
        title: 'Пост на модерации',
    },
    [PostStatus.DECLINED]: {
        title: 'Пост отклонен',
    },
    [PostStatus.PUBLISHED]: {
        title: 'Пост опубликован',
    },
    [PostStatus.DRAFT]: {
        title: 'Пост в черновиках',
    },
    [PostStatus.DELETED]: {
        title: 'Пост удален',
    },
    [PostStatus.LIMITED]: {
        title: 'Пост ограничен',
    },
};

const getDescriptionSlot = (status: PostStatus, onRulesClick: VoidFunction) => {
    const t = useTranslation();
    if (status === PostStatus.MODERATION) {
        return (
            <Typography variant="body">
                {t(
                    'Пост находится на модерации. После одобрения его смогут увидеть другие пользователи в вашей подборке.',
                )}
            </Typography>
        );
    }
    if (status === PostStatus.DECLINED) {
        return (
            <>
                <Typography variant="body">
                    {t('Пост отклонен по ')}
                    <Typography
                        variant="body"
                        display="inline"
                        as={Link}
                        to="https://yandex.ru/support2/rythm/ru/buisness/moderation#trebovaniya-k-tekstam"
                        color="link"
                        textDecoration="none"
                        onClick={onRulesClick}
                    >
                        {t('правилам сервиса')}
                    </Typography>
                    <br />
                </Typography>
                <Typography variant="body" display="inline" pt={2}>
                    {t('Если у вас остались вопросы, обращайтесь в поддержку, мы всегда на связи.')}
                </Typography>
            </>
        );
    }
};

interface PostStatusDialogState {
    post: PostModel;
}

export const PostStatusDialog = () => {
    const state = useLocation().state as PostStatusDialogState;
    const { post } = state;
    const onNavigateBack = useBackButton();
    const currentUser = useCurrentUser();
    const closeDialog = useCallback(() => {
        setTimeout(onNavigateBack, DEFAULT_CLOSE_ANIMATION_DELAY);
    }, [onNavigateBack]);
    const onRulesClick = useCallback(() => {
        ymTrackServiceRulesClick({
            userLogin: currentUser?.login,
            businessId: currentUser?.profile?.publicId,
            page: 'Пост',
        });
    }, [currentUser]);

    return (
        <EnhancedPostStatusDrawer
            post={post}
            index={0}
            handleClose={closeDialog}
            status={post.status}
            title={statusMap[post.status].title}
            descriptionSlot={getDescriptionSlot(post.status, onRulesClick)}
        />
    );
};
